function bytesToSize(bytes, seperator = "") {
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB']
    if (bytes == 0) return 'n/a'
    const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10)
    if (i === 0) return `${bytes}${seperator}${sizes[i]}`
    return `${Math.round((bytes / (1024 ** i)))}${seperator}${sizes[i]}`
}

export default bytesToSize